import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Configuration from "../configuration";
var token = localStorage.getItem("x-access-token");


export const getFileReleve = createAsyncThunk("relevenon/getFileReleve", async (file) => {
  const response = await fetch(Configuration.BACK_BASEURL + "relevenon/getFileReleve/"+file, {
    method: "GET",
    responseType: "blob",    
  }).then(response => response.blob())
  .then(function(myBlob) {
    return((myBlob))
  })
  .catch((error) => {
    console.log(error);
  })
  const files = await response;
  return files;
});
export const allReleveList = createAsyncThunk("relevenon/allReleveList", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "relevenon/allReleveList", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token':token
    },
    body:JSON.stringify(action)
  });
  const releve = await response.json();
  return releve;
});


//upload BL file
export const saveFile = createAsyncThunk("relevenon/saveFile", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "relevenon/saveFile", {
    method: 'POST',
    headers: {
      'Accept': 'application/*',
      'x-access-token':token,
    },
    body:action
  });
  const releve = await response.json();
  return releve;
});

export const releveAdded = createAsyncThunk("relevenon/releveAdded", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "relevenon/releveAdded", {
    method: 'POST',
    headers: {          
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token':token
    },
    body:JSON.stringify(action)
  });
  const releve = await response.json();
  return releve;
});


const releveNonReduce = createSlice({
  name: "relevenon",
  initialState: {
    entities: [],
    loading: false,
  },
  reducers: {
   
    deletereleve(state, action) {
      const { id } = action.payload;
      fetch(Configuration.BACK_BASEURL + "relevenon/delete/"+id, {
        method: 'DELETE',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'x-access-token':token
        },
      });
    },
  },
  extraReducers: (builder) => {

  },
  
});

export const {deletereleve  } = releveNonReduce.actions;

export default releveNonReduce.reducer;
